var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M7.324 19.28c1.123 0 2.034.9 2.034 2.01 0 1.109-.91 2.008-2.034 2.008-1.124 0-2.035-.9-2.035-2.009 0-1.11.91-2.008 2.035-2.008zm13.019 0c1.123 0 2.034.9 2.034 2.01 0 1.109-.91 2.008-2.034 2.008-1.125 0-2.034-.9-2.034-2.009 0-1.11.91-2.008 2.034-2.008zM7.164 2.41H24l-.081 1.079c-.018.227-.423 5.574-.596 6.703-.248 1.618-1.64 2.83-3.546 3.088-1.204.162-7.46.875-10.012 1.18v-2.023c2.68-.32 8.598-.993 9.736-1.146 1.006-.136 1.7-.67 1.81-1.397.109-.704.339-3.47.496-5.48H7.323V14.85c0 .74.528 1.218 1.343 1.218h13.711v2.008H8.667c-1.926 0-3.378-1.387-3.378-3.226V3.395c0-.739-.703-1.387-1.505-1.387H0V0h3.784c1.563 0 2.928 1.205 3.38 2.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3300cdcbec24ac291082bd6df6c47696.svg";
export { ForwardRef as ReactComponent };